import moment from 'moment';
import template from 'lodash/template';
import isNil from 'lodash/isNil';
import defaultLocale from '../../components/locale/defaultLocale';

export default function dateDistance(
  value,
  { distance = Infinity, max, min, distanceOptions = {}, locale = defaultLocale, ...rest }
) {
  const { end, invalidAllowed, start, type } = {
    type: 'months',
    start: !isNil(rest.start) ? rest.start : 'start',
    end: !isNil(rest.end) ? rest.end : 'end',
    invalidAllowed: false,
    // ...rest,
    ...distanceOptions
  };

  const endDate = moment(value[end] || value);
  const startDate = moment(value[start] || value);

  const timeDiff = endDate.diff(moment(startDate), type);
  const maxDate = max && moment(max);
  const minDate = min && moment(min);

  if (value[end] && value[start] && startDate > endDate) {
    return locale['dateTime.invalidRange'];
  }

  const hasInvalid = !startDate.isValid() || !endDate.isValid();
  if (hasInvalid && !invalidAllowed) {
    return locale['dateTime.invalidDate'];
  }

  if (timeDiff > distance) {
    return template(locale['common.maxRange'])({
      distance,
      end,
      type,
      start
    });
  }

  if (maxDate && endDate > maxDate) {
    return template(locale['common.maxRange'])({
      distance,
      end,
      type,
      start
    });
  }

  if (minDate && startDate < minDate) {
    return template(locale['common.maxRange'])({
      distance,
      end,
      type,
      start
    });
  }

  return null;
}
